import React from 'react';
import { shape, arrayOf, any, func, bool } from 'prop-types';
import { reduxForm } from 'redux-form';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { scrollToInvalid } from '@widergy/web-utils/lib/form';

import UTForm from 'app/components/UTForm';
import { USER_FORM_NAME } from 'constants/reduxForms';
import { UtFormFieldPropTypes } from 'types/formTypes';

import styles from './styles.module.scss';

const Form = ({
  handleSubmit,
  userForm,
  formAccount,
  fieldValues,
  isPublic,
  showTitle,
  ignoreVisibility,
  fieldClasses,
  fieldTypeProps
}) => (
  <form onKeyDown={handleKeyDown(handleSubmit)} className={styles.container}>
    <UTForm
      form={userForm}
      account={formAccount}
      fieldValues={fieldValues}
      isPublic={isPublic}
      showTitle={showTitle}
      formClasses={{ formTitle: styles.formTitle }}
      replaceFieldNames
      ignoreVisibility={ignoreVisibility}
      fieldClasses={fieldClasses}
      fieldTypeProps={fieldTypeProps}
    />
  </form>
);

Form.propTypes = {
  formAccount: any, // eslint-disable-line react/forbid-prop-types
  fieldClasses: any, // eslint-disable-line react/forbid-prop-types,
  fieldTypeProps: any, // eslint-disable-line react/forbid-prop-types
  userForm: shape({
    fields: arrayOf(UtFormFieldPropTypes).isRequired
  }).isRequired,
  fieldValues: any, // eslint-disable-line react/forbid-prop-types
  handleSubmit: func,
  isPublic: bool,
  showTitle: bool,
  ignoreVisibility: bool
};

export default reduxForm({ form: USER_FORM_NAME, onSubmitFail: errors => scrollToInvalid(errors) })(Form);
